module.exports = {"371726001":"陈王街道","371726002":"古泉街道","371726101":"什集镇","371726102":"红船镇","371726103":"旧城镇","371726104":"闫什镇","371726105":"箕山镇","371726106":"李进士堂镇","371726107":"董口镇","371726108":"临濮镇","371726109":"彭楼镇","371726110":"凤凰镇","371726111":"郑营镇","371726112":"大埝镇","371726113":"引马镇","371726114":"左营镇","371726115":"富春镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371726.json
// module id = 1627
// module chunks = 0